<template>
  <div class="flex items-center gap-2 truncate">
    <div
      v-for="(breadcrumb, idx) in breadcrumbs"
      :key="idx"
      class="flex items-center gap-2"
      :class="[
        breadcrumb.truncate
          ? 'truncate' + (idx + 1 < breadcrumbs.length ? ' max-w-64' : '')
          : 'flex-shrink-0'
      ]"
    >
      <BlTextSubtitle3
        v-if="idx > 0"
        class="text-slate-600 flex-shrink-0"
        text="/"
      />
      <router-link
        v-if="breadcrumb.target"
        :to="breadcrumb.target"
        :title="breadcrumb.label"
        :class="[breadcrumb.truncate ? 'truncate' : 'flex-shrink-0']"
      >
        <BlTextSubtitle3
          :class="[
            breadcrumb.truncate ? 'truncate' : 'flex-shrink-0',
            idx + 1 < breadcrumbs.length ? 'text-slate-600' : ''
          ]"
          class="hover:text-slate-800 transition-all duration-300"
          :text="breadcrumb.label"
        />
      </router-link>
      <div
        v-if="breadcrumb.action"
        @click.prevent="breadcrumb.action"
        :title="breadcrumb.label"
        class="cursor-pointer"
        :class="[breadcrumb.truncate ? 'truncate' : 'flex-shrink-0']"
      >
        <BlTextSubtitle3
          :class="[
            breadcrumb.truncate ? 'truncate' : 'flex-shrink-0',
            idx + 1 < breadcrumbs.length ? 'text-slate-600' : ''
          ]"
          class="hover:text-slate-800 transition-all duration-300"
          :text="breadcrumb.label"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BlTextSubtitle3 from "./BlTextSubtitle3.vue";
export default {
  name: "BlBreadcrumbs",
  components: { BlTextSubtitle3 },
  props: {
    breadcrumbs: {
      type: Array,
      requred: true,
      default: () => [{ label: "", target: "", action: "", truncate: false }]
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlBreadcrumbs.vue